import React from 'react';
import { Row, Col, Button, Dropdown } from "antd";
import { Link, useNavigate , useLocation } from "react-router-dom";
import type { MenuProps } from 'antd';
import axios from "axios";
import logo from "../assets/logo.svg"
import '../assets/header.scss';

function Header() {
  let user = JSON.parse(localStorage.getItem("user_info")!);
  let navigate = useNavigate();
  const location = useLocation();

  const goToLoginPage = () => {
    navigate("/login");
  };

  const handleLogOut = () => {
    localStorage.clear();
    axios.defaults.headers.common["Authorization"] = "";
    navigate("/login");
  }

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <div onClick={() => handleLogOut()}>
          Đăng xuất
        </div>
      ),
    },
  ];
  
  return (
    <header id="root-header" className="header-page">
      <div className="container header-container">
        <Row justify="space-between" align="middle">
          <Col span={4}><img className="header-logo" src={logo} alt="logo" /></Col>
          <Col span={20}>
            <Row justify="end" align="middle" gutter={16}>
              <Col flex="150px">
                <Link to="/"  className="header-link">Danh sách Ekyc</Link>
              </Col>
              <Col flex="100px">
                <Link to="/health-check" className="header-link">Danh sách SKTCCN</Link>
              </Col>
              {user ? (
                <>
                  <Col flex="150px">
                    <Dropdown menu={{ items }} placement="bottomLeft" arrow>
                      <Button className='btn-register logined'>
                        <span>{`Xin chào, ${user.full_name}`}</span>
                      </Button>
                    </Dropdown>
                  </Col>
                </>) : (
                <>
                  <Col flex="150px">
                    <Button className='btn-register' onClick={goToLoginPage}>
                      <span>Đăng nhập</span>
                    </Button>
                  </Col>
                </>
              )}
            </Row>
          </Col>
        </Row>
      </div>
    </header>
  );
}

export default React.memo(Header);